export const PLS_PHASE_NOTICE_DURATION_MS = 60 * 1000

const PHASE_NOTICES = {
    escalation: {
        titleKey: 'pls.escalation.title',
        sound: '/sounds/Upward-PLS.mp3',
        variant: 'escalation'
    },
    deescalation: {
        titleKey: 'pls.deescalation.title',
        sound: '/sounds/Downward-PLS.mp3',
        variant: 'deescalation'
    }
}

/**
 * Decide si hay que mostrar el aviso al cambiar de fase.
 * Cuando la API informe la fase, la vista solo tiene que pasar la anterior y la nueva.
 *
 * @param {{ previousPhase?: string|null, nextPhase?: string|null }} params
 * @returns {{ titleKey: string, sound: string, variant: string, durationMs: number }|null}
 */
export function resolvePlsPhaseNotice({ previousPhase = null, nextPhase = null } = {}) {
    const phase = PHASE_NOTICES[nextPhase]

    if (!phase || previousPhase === nextPhase) {
        return null
    }

    return {
        titleKey: phase.titleKey,
        sound: phase.sound,
        variant: phase.variant,
        durationMs: PLS_PHASE_NOTICE_DURATION_MS
    }
}

const SALES_RAMP_ACTIONS = {
    escalada: 'escalation',
    descalada: 'deescalation'
}

function padTimeUnit(value) {
    return String(value).padStart(2, '0')
}

function readSalesRamp(salesRamp) {
    if (typeof salesRamp === 'string') {
        try {
            return JSON.parse(salesRamp)
        } catch (_) {
            return null
        }
    }

    return salesRamp
}

/**
 * Formatea la hora del dispositivo como clave de franja (YYYY-MM-DD HH:mm).
 * La vista solo debe llamarla cuando el minuto es 00 o 30.
 *
 * @param {Date|string|number} date
 * @returns {string|null}
 */
export function salesRampSlotKey(date) {
    const value = date instanceof Date ? date : new Date(date)

    if (Number.isNaN(value.getTime())) {
        return null
    }

    const day = `${value.getFullYear()}-${padTimeUnit(value.getMonth() + 1)}-${padTimeUnit(value.getDate())}`
    const time = `${padTimeUnit(value.getHours())}:${padTimeUnit(value.getMinutes())}`

    return `${day} ${time}`
}

/**
 * Traduce la etiqueta de una franja de sales_ramp a la acción del toast.
 * Sin el campo, con label null o con una etiqueta desconocida no hay aviso.
 *
 * @param {object|string|null|undefined} salesRamp
 * @param {string|null} slotKey
 * @returns {'escalation'|'deescalation'|null}
 */
export function resolveSalesRampAction(salesRamp, slotKey) {
    const ramp = readSalesRamp(salesRamp)

    if (!ramp || typeof ramp !== 'object' || Array.isArray(ramp) || !slotKey) {
        return null
    }

    const slot = ramp[slotKey] || ramp[`${slotKey}:00`]

    if (!slot || typeof slot !== 'object') {
        return null
    }

    return SALES_RAMP_ACTIONS[slot.label] || null
}
